import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../../../../base/icons/icon/index.js";
import { nullsToUndefined } from "../../../../../../../helpers/null.js";
import { defaultWidth } from "../constants.js";
import * as S from "../styled.js";
export const ViewMoreMasonryCard = ({ view_more , count , heights  })=>/*#__PURE__*/ _jsxs(S.MasonryCard, {
        ...nullsToUndefined(view_more?.link),
        children: [
            /*#__PURE__*/ _jsx(S.MasonryViewMoreBack, {
                $paddingTop: `${Math.ceil(heights[count + 1] * 100) / defaultWidth}%`
            }),
            /*#__PURE__*/ _jsxs(S.MasonryViewMore, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "nico-plus"
                    }),
                    view_more?.link.content
                ]
            })
        ]
    });
export default ViewMoreMasonryCard;

//# sourceMappingURL=viewMoreMasonryCard.js.map